'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertCloseButton } from './AlertCloseButton';
import { forwardRef } from 'react';
import { AlertDescription } from './AlertDescription';
import { AlertTitle } from './AlertTitle';
import { AlertRoot } from './AlertRoot';
import { AlertContent } from './AlertContent';
import clsx from 'clsx';
import { AlertIconBox } from './AlertIconBox';
import { useId } from '../hooks';
import { getAlertIcon } from './utils/getAlertIcon';
export const Alert = forwardRef((props, ref) => {
    const { id, title, children, className, icon, variantIconMapping: userSpecifiedIcons, hasCloseButton, onClose, closeButtonAriaLabel = 'Close', ...alertRootProps } = props;
    const resolvedId = useId(id);
    const resolvedIcon = icon ?? getAlertIcon(alertRootProps.variant, userSpecifiedIcons);
    return (_jsxs(AlertRoot, { "aria-describedby": `${resolvedId}-description`, "aria-labelledby": `${resolvedId}-title`, className: clsx('Alert-root', className), id: resolvedId, ref: ref, role: 'alert', ...alertRootProps, children: [resolvedIcon && (_jsx(AlertIconBox, { className: 'Alert-icon', children: resolvedIcon })), _jsxs(AlertContent, { className: 'Alert-content', children: [title && (_jsx(AlertTitle, { className: 'Alert-title', id: `${resolvedId}-title`, children: title })), children && (_jsx(AlertDescription, { className: 'Alert-description', id: `${resolvedId}-description`, children: children }))] }), hasCloseButton && (_jsx(AlertCloseButton, { "aria-label": closeButtonAriaLabel, className: 'Alert-iconButton', onClick: onClose }))] }));
});
Alert.displayName = 'Alert';
